import React, { useState } from 'react';
import { ActivityIndicator, Text, View, Pressable } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { ACCOUNT_DELETION_GRACE_DAYS } from '../../services/userService';

type Props = {
  onReactivate: () => Promise<void>;
  onLogout: () => Promise<void>;
};

export function SuspendedAccountScreen({ onReactivate, onLogout }: Props) {
  const insets = useSafeAreaInsets();
  const [busy, setBusy] = useState<'reactivate' | 'logout' | null>(null);

  return (
    <View
      className="flex-1 bg-white px-6 dark:bg-black"
      style={{ paddingTop: insets.top + 32, paddingBottom: insets.bottom + 24 }}>
      <Text className="text-center text-xl font-bold text-zinc-900 dark:text-zinc-50">
        Üyeliğiniz askıda
      </Text>
      <Text className="mt-4 text-center text-base leading-6 text-zinc-600 dark:text-zinc-400">
        Hesabınızı silme talebiniz alınmıştır. {ACCOUNT_DELETION_GRACE_DAYS} gün içinde giriş yapıp
        hesabınıza devam edebilirsiniz; bu süre içinde giriş yapmazsanız üyeliğiniz tamamen
        kaldırılır.
      </Text>
      <Pressable
        disabled={busy !== null}
        onPress={() => {
          setBusy('reactivate');
          void onReactivate().finally(() => setBusy(null));
        }}
        className="mt-10 rounded-xl bg-zinc-900 py-3.5 active:opacity-90 disabled:opacity-50 dark:bg-zinc-50">
        {busy === 'reactivate' ? (
          <ActivityIndicator color="#ffffff" />
        ) : (
          <Text className="text-center text-base font-semibold text-white dark:text-zinc-950">
            Hesabıma devam et
          </Text>
        )}
      </Pressable>
      <Pressable
        disabled={busy !== null}
        onPress={() => {
          setBusy('logout');
          void onLogout().finally(() => setBusy(null));
        }}
        className="mt-4 rounded-xl border border-zinc-300 py-3.5 active:opacity-80 dark:border-zinc-600">
        {busy === 'logout' ? (
          <ActivityIndicator color="#71717a" />
        ) : (
          <Text className="text-center text-base font-semibold text-zinc-600 dark:text-zinc-300">
            Çıkış yap
          </Text>
        )}
      </Pressable>
    </View>
  );
}
